import React from 'react';
import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile, useStyles } from '@sravni/react-utils';
import img$1 from '../images/app.webp.js';
import img from '../images/qr.png.js';
import modules_034cfbf6 from '../styles/AppBanner.module.less.js';

const AppBanner = React.forwardRef(({ className, variant = 'primary', ...rest }, ref) => {
    const isMobile = useIsMobile();
    const cx = useStyles(modules_034cfbf6);
    const isPrimary = variant === 'primary';
    return (React.createElement(Card, { size: isMobile ? 16 : 24, color: isPrimary ? 'dark' : 'light', className: cx(className, modules_034cfbf6.container), ...rest },
        React.createElement(Space, { size: 24 },
            React.createElement(Space, { align: "center", justify: "center", className: modules_034cfbf6.qrWrapper },
                React.createElement("img", { ref: ref, "data-store": "QR", width: 80, height: 80, src: img, alt: "Download app from qr" })),
            React.createElement(Space, { direction: "column", size: 8, className: modules_034cfbf6.titleContainer },
                React.createElement(Heading, { level: 4 }, "\u0421\u0440\u0430\u0432\u043D\u0438 \u0432\u00A0\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438"),
                React.createElement(Text, { size: 12 }, "\u041E\u0444\u043E\u0440\u043C\u043B\u044F\u0439\u0442\u0435 \u0443\u0441\u043B\u0443\u0433\u0438, \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0439\u0442\u0435 \u043F\u043E\u043B\u0438\u0441\u044B \u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0439\u0442\u0435 \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u044B\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433")),
            React.createElement("div", { className: modules_034cfbf6.stub }),
            React.createElement("img", { width: 160, height: 144, className: modules_034cfbf6.appImg, src: img$1, alt: "Application view" }))));
});
AppBanner.displayName = 'AppBanner';

export { AppBanner };
//# sourceMappingURL=AppBanner.js.map
